import { TransportOrderIdView } from '../../../../models';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { MeasurementUnitCodesEnum } from '../../../../../common/models/unit-system.model';
import { LoadAllFacade, SetInitialStateFacade } from '../../../../../common';
import { ShipmentTransportOrderEquipmentsState } from './shipment-transport-order-equipments.state';
import { Observable } from 'rxjs';
import { WaybillEquipmentItemModel } from '../../../../models/waybill-equipments.model';
import {
  ShipmentTransportOrderEquipmentsInitialState,
  ShipmentTransportOrderEquipmentsLoad,
} from './shipment-transport-order-equipments.actions';

@Injectable({
  providedIn: 'root',
})
export class ShipmentTransportOrderEquipmentsFacade implements LoadAllFacade, SetInitialStateFacade {
  equipments$: Observable<WaybillEquipmentItemModel[]> = this.store.select(
    ShipmentTransportOrderEquipmentsState.getEquipments,
  );
  dimensionsUnitCode$: Observable<MeasurementUnitCodesEnum> = this.store.select(
    ShipmentTransportOrderEquipmentsState.getDimensionsUnitCode,
  );
  weightUnitCode$: Observable<MeasurementUnitCodesEnum> = this.store.select(
    ShipmentTransportOrderEquipmentsState.getWeightUnitCode,
  );
  volumeUnitCode$: Observable<MeasurementUnitCodesEnum> = this.store.select(
    ShipmentTransportOrderEquipmentsState.getVolumeUnitCode,
  );
  loaded$: Observable<boolean> = this.store.select(ShipmentTransportOrderEquipmentsState.getLoaded);

  constructor(private store: Store) {}

  loadAll(identifier: TransportOrderIdView): void {
    this.store.dispatch(new ShipmentTransportOrderEquipmentsLoad(identifier));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentTransportOrderEquipmentsInitialState());
  }
}
